// extracted by mini-css-extract-plugin
export default {"descTwo":"DescTwo_descTwo__tws1L"};